export const DEFAULT_THEME = {
  primaryColor: '#1a56db',
  secondaryColor: '#ffffff',
  textColor: '#1a1a1a',
  backgroundColor: '#f3f4f6',
  headerStyle: 'default',
  font: 'Inter'
} as const;

export type Theme = typeof DEFAULT_THEME; 